
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[country]",
      function () {
        return require("private-next-pages/destinations/[country].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[country]"])
      });
    }
  